import { Component } from '@angular/core';
import { CustomTranslateService } from '@services/common/custom-translate.service';
import { ClientAppConfig } from 'app/@types/shared/app-config';
import { ConfigService } from 'app/app-config.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'app-freetrial-expiration',
    templateUrl: './freetrial-expiration.component.html',
    styleUrls: ['./freetrial-expiration.component.scss'],
    standalone: false,
})
export class FreetrialExpirationComponent {
    public client?: ClientAppConfig;
    public dCarbonizeMail: string;
    public mainColor: string;

    constructor(
        private configService: ConfigService,
        private ref: DynamicDialogRef,
        public translateService: CustomTranslateService,
    ) {
        this.client = this.configService.getClient;
        this.dCarbonizeMail = this.client.support?.mailDcarbonize ?? '';
        this.mainColor = this.configService.brand.primary;
    }

    public onClickContactUs() {
        forkJoin([
            this.translateService.get('common.freetrialExpire.mail.subject'),
            this.translateService.get('common.freetrialExpire.mail.body'),
        ]).subscribe(([subject, body]) => {
            const mail = `mailto:${this.dCarbonizeMail}?&subject=${encodeURIComponent(
                subject as string,
            )}&body=${encodeURIComponent(body as string)}`;

            window.open(mail, 'emailWindow');
        });
    }
    /** Closes the dialog; the login page then clears the expiry from its address. */
    public close(): void {
        this.ref.close();
    }
}
